import Registry from 'live/services/registry'
import React from 'react'

type StaticDataManagerComponent = {
    props: Record<string, unknown>
}

type StaticDataManagerRegistry = {
    id: string
    Component: React.ComponentType<StaticDataManagerComponent>
}

export function componentExtractor(
    registry: StaticDataManagerRegistry
): React.ComponentType<StaticDataManagerComponent> {
    return registry?.Component
}

export const RunModalRegistryService = {
    registry: new Registry<StaticDataManagerRegistry>()
}

export const RunTabRegistryService = {
    registry: new Registry<StaticDataManagerRegistry>()
}
